let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("liMu2")).then(() => parcelRequire('4yqs9'));